import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IPendingReviewAPIResponse } from './Types';

export interface IGetPendingReviewPayload {
  limit: number;
  page: number;
}

const getShiftPendingReviews = async ({
  page = 1,
  limit = 10,
}: IGetPendingReviewPayload): Promise<IPendingReviewAPIResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IPendingReviewAPIResponse>(
    '/jobs/dashboard/pending-review',
    {
      headers,
      params: {
        limit,
        page,
      },
    },
  );

  return response.data;
};

export const shiftReviewApi = {
  getShiftPendingReviews,
};
